import { render } from "./copyFoodModel.vue?vue&type=template&id=f892662a"
import script from "./copyFoodModel.vue?vue&type=script&lang=js"
export * from "./copyFoodModel.vue?vue&type=script&lang=js"

import "./copyFoodModel.vue?vue&type=style&index=0&id=f892662a&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__